<template>
  <v-content>
    <!-- Desktop -->
    <section v-if="$vuetify.breakpoint.mdAndUp" style="margin-top: 64px;">
      <v-layout row wrap>
        <v-flex xs12 text-xs-center class="font-number-2 white--text py-4">FAQ</v-flex>
      </v-layout>
      <v-layout row wrap class="font-heading pb-5">
        <!-- Questions -->
        <v-flex xs8 offset-xs2 class="px-4">
          <v-expansion-panel popout>
            <v-expansion-panel-content v-for="(item, i) in howTOs" :index="i" :key="i">
              <!-- Titles -->
              <div v-if="language == 'en'" slot="header">{{item.questionEN}}</div>
              <div v-else-if="language == 'fi'" slot="header">{{item.questionFI}}</div>
              <div v-else-if="language == 'sv'" slot="header">{{item.questionSV}}</div>
              <v-stepper non-linear>
                <v-stepper-header>
                  <!-- Steps -->
                  <template v-for="(step, n) in item.steps">
                    <v-stepper-step :key="n" :step="n + 1" editable>
                      <div v-if="language == 'en'">{{item.steps[n].textEN}}</div>
                      <div v-else-if="language == 'fi'">{{item.steps[n].textFI}}</div>
                      <div v-else-if="language == 'sv'">{{item.steps[n].textSV}}</div>
                    </v-stepper-step>
                    <!-- Divider -->
                    <v-divider v-if="n < (item.steps.length - 1)" :key="n"></v-divider>
                  </template>
                </v-stepper-header>
                <v-stepper-items>
                  <!-- Step Images -->
                  <template v-for="(step, n) in item.steps">
                    <v-stepper-content :key="n" :step="n + 1">
                      <video
                        v-if="item.steps[n].hasOwnProperty('webm')"
                        oncontextmenu="return false;"
                        v-bind:src="step.webm"
                        style="width: 100%"
                        loop
                        muted
                        autoplay
                      ></video>
                      <img
                        v-else
                        oncontextmenu="return false;"
                        v-bind:src="step.img"
                        style="width: 100%"
                      >
                    </v-stepper-content>
                  </template>
                </v-stepper-items>
              </v-stepper>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </section>
    <!-- Mobile -->
    <section v-else class="mx-3" style="margin-top: 56px;">
      <v-flex xs12 text-xs-center v-lang.contact class="font-number-2 white--text my-5 py-5"></v-flex>
      <v-layout row wrap justify-center class="pb-5">
        <!-- Questions -->
        <!--  <v-flex xs12 sm10>
           <v-expansion-panel popout>
            <v-expansion-panel-content v-for="(item, i) in howTOsMobile" :index="i" :key="i">
              Titles
              <div v-if="language == 'en'" slot="header">{{item.questionEN}}</div>
              <div v-else-if="language == 'fi'" slot="header">{{item.questionFI}}</div>
              <div v-else-if="language == 'sv'" slot="header">{{item.questionSV}}</div>
              <v-stepper non-linear>
                <v-stepper-header>
                  Steps
                  <template v-for="(step, n) in item.steps">
                    <v-stepper-step :key="n" :step="n + 1" editable></v-stepper-step>
                    Divider
                    <v-divider v-if="n < (item.steps.length - 1)" :key="n"></v-divider>
                  </template>
                </v-stepper-header>
                <v-stepper-items>
                  Step Images
                  <template v-for="(step, n) in item.steps">
                    <v-stepper-content :key="n" :step="n + 1">
                      <video v-if="item.steps[n].hasOwnProperty('webm')" oncontextmenu="return false;" v-bind:src="step.webm" style="width: 100%" loop muted autoplay></video>
                      <img v-else oncontextmenu="return false;" v-bind:src="step.img" style="width: 100%">
                    </v-stepper-content>
                  </template>
                </v-stepper-items>
              </v-stepper>
            </v-expansion-panel-content>
          </v-expansion-panel>           
        </v-flex>-->
        <v-flex xs12 text-xs-center class="pb-2">
          <v-icon class="blue--text">phone</v-icon>&nbsp;
          <span>+358 45 7731 1550</span>
        </v-flex>
        <v-flex xs12 text-xs-center class="pb-2">
          <v-icon class="amber--text">email</v-icon>&nbsp;
          <span>virtual@electrowaves.fi</span>
        </v-flex>
        <v-flex xs12 v-lang.contactDes class="mt-5 pt-5" style="text-align: justify;"></v-flex>
      </v-layout>
    </section>
    <!-- Footer -->
    <c-footer></c-footer>
  </v-content>
</template>

<script>
import CFooter from "./Footer";

export default {
  data() {
    return {
      howTOs: [
        {
          questionEN: "How to create a class?",
          questionFI: "Miten luodaan tunti?",
          questionSV: "Hur skapar man en klass?",
          steps: [
            {
              textEN: "Select Player",
              textFI: "Valitse laite",
              textSV: "Välj enhet",
              webm: "public/images/help/create_class_d_1.webm"
            },
            {
              textEN: "Select Class & Time",
              textFI: "Valitse tunti ja aika",
              textSV: "V klass och tid",
              webm: "public/images/help/create_class_d_2.webm"
            },
            {
              textEN: "Assign to Date & Save",
              textFI: "Valitse päivämäärä ja tallenna",
              textSV: "Välj till datum och spara",
              webm: "public/images/help/create_class_d_3.webm"
            }
          ]
        },
        {
          questionEN: "How to delete a class?",
          questionFI: "Kuinka poistaa tunti?",
          questionSV: "Hur tar man bort en klass?",
          steps: [
            {
              textEN: "Select Player & Click Modify",
              textFI: "Valitse laite ja klikkaa muokkaa",
              textSV: "Välj spelare och klicka ändra",
              webm: "public/images/help/delete_class_d_1.webm"
            },
            {
              textEN: "Click Delete & Confirm",
              textFI: "Valitse poista ja vahvista",
              textSV: "Klicka på ta bort och bekräfta",
              webm: "public/images/help/delete_class_d_2.webm"
            }
          ]
        },
        {
          questionEN: "How to copy a week?",
          questionFI: "Kuinka kopioida viikko?",
          questionSV: "Så här kopierar du en vecka?",
          steps: [
            {
              textEN: "Click Modify & Select Week",
              textFI: "Klikkaa muokkaa ja valitse viikko",
              textSV: "klicka på ändra och välj vecka",
              webm: "public/images/help/copy_week_d_1.webm"
            },
            {
              textEN: "Copy, Paste & Save",
              textFI: "Kopioi, liitä ja tallenna",
              textSV: "Kopiera, klistra in och spara",
              webm: "public/images/help/copy_week_d_2.webm"
            }
          ]
        },
        {
          questionEN: "How to clear a week?",
          questionFI: "Kuinka tyhjentää viikko?",
          questionSV: "Hur rensar du en vecka?",
          steps: [
            {
              textEN: "Click Modify & Select Week",
              textFI: "Klikkaa muokkaa ja valitse viikko",
              textSV: "klicka på ändra och välj vecka",
              webm: "public/images/help/clear_week_d_1.webm"
            },
            {
              textEN: "Click Clear & Save",
              textFI: "Klikkaa tyhjennä ja tallenna",
              textSV: "Klicka på rensa och spara",
              webm: "public/images/help/clear_week_d_2.webm"
            }
          ]
        },
        {
          questionEN: "How to use the statistics?",
          questionFI: "Miten tilastoja käytetään?",
          questionSV: "Hur använder man statistiken?",
          steps: [
            {
              textEN: "Select Player & Date",
              textFI: "Valitse laite ja päivä",
              textSV: "Välj enhet, datum",
              webm: "public/images/help/stats_d_1.webm"
            },
            {
              textEN: "Select Class & Update",
              textFI: "Valitse tunti ja päivitä",
              textSV: "Välj klass och uppdatera",
              webm: "public/images/help/stats_d_2.webm"
            },
            {
              textEN: "Likes & Dislikes",
              textFI: "Tykkäykset",
              textSV: "Gillar",
              webm: "public/images/help/stats_d_3.webm"
            }
          ]
        }
      ],
      howTOsMobile: [
        {
          questionEN: "Reporting Errors.",
          questionFI: "Raportointivirheet",
          questionSV: "Rapporteringsfel.",
          steps: [
            {
              textEN: "Contact Maintenance",
              textFI: "Ota yhteyttä ylläpitoon",
              textSV: "Kontakta underhåll",
              img: "public/images/help/contact.png"
            }
          ]
        }
      ]
    };
  },
  components: {
    CFooter
  },
  methods: {
    newBtnLang() {
      if (this.language == "en") {
        return "New";
      } else if (this.language == "fi") {
        return "Uusi";
      } else {
        return "Ny";
      }
    }
  }
};
</script>

<style>
textarea:focus {
  outline: none !important;
  border-color: #719ece;
  box-shadow: 0 0 10px #719ece;
}
</style>





// WEBPACK FOOTER //
// src/components/Help.vue